import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://65ab6c27cf6d1728e2d34c911deecaa3@o437901.ingest.us.sentry.io/4507142227820544",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});